import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyComponent } from './privacy-policy.component';
import { PrivacyPolicyRoutingModule } from "./privacy-policy-routing.module";
import { TranslatePipe } from "@ngx-translate/core";



@NgModule({
  declarations: [
    PrivacyPolicyComponent
  ],
    imports: [
        CommonModule,
        PrivacyPolicyRoutingModule,
        TranslatePipe
    ]
})
export class PrivacyPolicyModule { }
